import React, { useEffect } from "react";
import Modal from "../ui/Modal";
import Form, { FormField } from "../ui/Form";
import { useAppDispatch, useAppSelector } from "src/redux/hooks";
import * as supplierActions from "src/redux/slices/supplierSlice";
import { toast } from "react-toastify";

interface AddSupplierModalProps {
  open: boolean;
  supplier?: any;
  onClose: () => void;
  onSuccess: () => void;
}

const AddSupplierModal: React.FC<AddSupplierModalProps> = ({
  open,
  supplier = null,
  onClose,
  onSuccess,
}) => {
  const dispatch = useAppDispatch();
  const { createSupplier, editSupplier } = useAppSelector(
    (state) => state.supplier
  );
  const {
    user: { data: user },
  } = useAppSelector((state) => state.authTenant);

  useEffect(() => {
    if (createSupplier.data) {
      toast.success("Supplier created successfully");
      handleClose();
    } else if (createSupplier.error) {
      toast.error(`Error: ${createSupplier.error}`);
    }
  }, [createSupplier]);

  useEffect(() => {
    if (editSupplier.data) {
      toast.success("Supplier updated successfully");
      handleClose();
    } else if (editSupplier.error) {
      toast.error(`Error: ${editSupplier.error}`);
    }
  }, [editSupplier]);

  const handleClose = () => {
    dispatch(supplierActions.resetCreateSupplier());
    dispatch(supplierActions.resetEditSupplier());
    onSuccess();
  };

  const fields: FormField[] = [
    {
      label: "Supplier Name",
      name: "name",
      type: "text",
      validations: { required: true },
    },
    { label: "Contact Person", name: "contactPerson", type: "text" },
    { label: "Email", name: "email", type: "email" },
    { label: "Phone", name: "phone", type: "text" },
    { label: "GST Number", name: "gstNumber", type: "text" },
    { label: "Address", name: "address", type: "textarea" },
  ];

  const handleSubmit = (data: Record<string, any>) => {
    if (supplier?._id) {
      dispatch(
        supplierActions.editSupplierRequest({
          ...data,
          _id: supplier._id,
        })
      );
    } else {
      dispatch(
        supplierActions.createSupplierRequest({
          ...data,
        })
      );
    }
  };

  const pageTitle = supplier?._id ? "Edit Supplier" : "Create Supplier";

  return (
    <Modal open={open} onClose={onClose} title={pageTitle}>
      <Form
        initialState={supplier as any}
        fields={fields}
        onSubmit={handleSubmit}
        onCancel={onClose}
        loading={createSupplier.loading || editSupplier.loading}
      />
    </Modal>
  );
};

export default AddSupplierModal;
